var indentStyle = {"indentZero":"hkThF","indentOne":"E6uX8","indentTwo":"Smpvn","indentThree":"DcMfB","indentFour":"ecvhS","indentFive":"dGb3f","indentSix":"yDlf0"};

export { indentStyle as i };
//# sourceMappingURL=indentation-b918047c.js.map
